import { useCallback } from 'react';
import { jobOffer as jobOfferEntity } from '@vette/common-utils';
import { message } from '@vette/frontend-utils';

export const useHandleInactiveJobOffer = (
  disableForm: () => void,
  isPredemo?: boolean
) => {
  const displayError = (msg: string) => message.error(msg, 0);

  return useCallback(
    (reason: jobOfferEntity.DisableErrorReason) => {
      if (reason === 'DISABLED') {
        displayError(
          "Oh no! We are so sorry. This job is already closed. We know that finding a new job is hard but please keep your chin up and don't give up! You've got this."
        );
      } else if (reason === 'RAN_OUT_OF_VETTES') {
        displayError(
          "Sorry, we aren't able to interview for this job right now. Interviews may become available again later, feel free to check back."
        );
      } else if (reason === 'DUPLICATE_INTERVIEW') {
        displayError(
          isPredemo
            ? 'Oops, it looks like you already experienced that magical moment!'
            : 'Oops, it looks like you already interviewed for this role!'
        );
      } else if (reason === 'APPLICANT_DID_NOT_PASS_KNOCKOUT') {
        displayError(
          `At this time, it appears that you may not quite meet the qualifications for this job. Don't let that discourage you! Keep your head up and don't give up on your search.`
        );
      } else if (reason === 'APPLICANT_PHONE_IS_BLACKLISTED') {
        displayError(`This Phone number cannot be reached at the moment.`);
      } else {
        displayError(
          "Oh no! We are so sorry. This job is temporarily disabled. We know that finding a new job is hard but please keep your chin up and don't give up! You've got this."
        );
      }
      disableForm();
    },
    [disableForm]
  );
};
